// localStorage-backed "Recent" entries for the CommandPalette. Entities only
// (leads/clients the user actually jumped to) — pages are always one
// keystroke away, recents are for "that lead I opened an hour ago".
const KEY = "palette:recents";
const MAX = 5;

export const getRecents = () => {
  try {
    const value = JSON.parse(localStorage.getItem(KEY));
    return Array.isArray(value) ? value.slice(0, MAX) : [];
  } catch {
    return [];
  }
};

export const pushRecent = (entry) => {
  if (!entry || !entry.route) return;
  try {
    const next = [
      entry,
      ...getRecents().filter((e) => e.route !== entry.route),
    ].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // storage full/blocked — recents are a nicety, never an error
  }
};

export const clearRecents = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
};
